<template>
  <div class="app-wrapper">
    <div class="fixed-header">
      <div class="navbar-container">
        <div class="sidebar-left">
          <div data-v-ef97e323="" class="logo">
            <div data-v-ef97e323="" class="sidebar-logo-link">
              <!-- <img src="../assets/images/logo.png" class="sidebar-logo" /> -->
              <img v-if="logo" class="sidebar-logo" :src="logo" />
              <div
                data-v-ef97e323=""
                class="logtitle btn-septcuts qt-dropdown-btn"
                aria-describedby="qt-dropdown-list-6160"
              >
                <svg data-v-ef97e323="" aria-hidden="true" class="list-icon">
                  <use href="#icon-list" fill="#303133"></use>
                </svg>
                答题卡制作
              </div>
            </div>
          </div>
        </div>
        <div class="user-menus-container">
          <el-dropdown placement="bottom" @command="handleCommand">
            <div class="user-dropdown el-dropdown">
              <span
                align-items-center
                class="el-dropdown-link el-dropdown-selfdefine"
                role="button"
                tabindex="0"
                ><span class="ru">{{ user.schoolName }}</span
                ><span class="username">{{ user.name || '' }}</span
                ><i class="el-icon-caret-bottom el-icon--right"></i
              ></span>
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown-items">
              <!-- :data-unit="userInfo.school_type == 1 ? '校' : '联'" -->
              <el-dropdown-item command="change" class="school-item"
                >{{ user.schoolName }}
                <el-button
                  type="primary"
                  round
                  size="mini"
                  style="padding: 3px 10px"
                  ><span>切换</span></el-button
                >
                <span class="rucode"
                  >（{{ user.account }}）</span
                ></el-dropdown-item
              >

              <el-dropdown-item class="account-item" command="logout"
                ><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <!-- <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ user.name }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="out">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
      </div>
    </div>
    <div class="detail-container">
      <div class="appmain">
        <div class="HomeIndex">
          <div style="padding: 10px; width: 100%">
            <el-form :inline="true" size="small" :model="search">
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  flex-wrap: wrap;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <el-form-item>
                  <el-select
                    style="width: 150px"
                    v-model="search.acPeriod"
                    placeholder="请选择年级"
                    clearable
                  >
                    <el-option
                      v-for="item in grades"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    style="width: 150px"
                    v-model="search.acksType"
                    placeholder="选择考试类型"
                    clearable
                  >
                    <el-option
                      v-for="item in examType"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    style="width: 150px"
                    v-model="search.acKmCode"
                    placeholder="选择科目"
                    clearable
                  >
                    <el-option
                      v-for="item in acsubjects"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    style="width: 150px"
                    v-model="search.acCardName"
                    placeholder="请输入答题卡名称"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchClick"
                    >查询</el-button
                  >
                  <el-button type="primary" @click="createDtk"
                    >新建答题卡</el-button
                  >
                </el-form-item>
              </div>
            </el-form>
            <el-row class="card-type">
              <el-col :span="24">
                <el-radio-group v-model="search.isPrivate" @change="changeType">
                  <el-radio-button :label="1">我的答题卡</el-radio-button>
                  <el-radio-button :label="2">公共答题卡</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-table :data="acCardList" stripe>
              <el-table-column label="文件名" prop="name">
                <template slot-scope="scope">
                  <div>{{ getChinsesCardName(scope.row.acCardName) }}</div>
                  <div
                    style="
                      font-size: 12px;
                      font-weight: 400;
                      color: #909399;
                      line-height: 30px;
                    "
                  >
                    {{ scope.row.acPeriod ? scope.row.acPeriod + '|' : '' }}
                    {{ scope.row.acKmCode ? scope.row.acKmCode + '|' : ''
                    }}{{ scope.row.acksType }} 答题卡模式:{{
                      scope.row.acCardStudentCodeType
                        | acCardStudentCodeTypeFilter
                    }}
                    | 批阅方式:{{
                      scope.row.acCardYJType | acCardYJTypeFilter
                    }}
                    | 分栏:{{ scope.row.acCardPanes | acCardPanesFilter }} 
                    <span v-if="user.teacherId != scope.row.createUserId">| 创建人：<el-tag type="info" size="small">{{scope.row.teacherName || '-'}}</el-tag></span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" prop="createAt">
              </el-table-column>
              <el-table-column label="操作" prop="option" align="center">
                <template slot-scope="{ row }">
                  <el-button
                    @click="handleEdit(row)"
                    type="text"
                    v-if="search.isPrivate==1"
                    >编辑</el-button
                  >
                  <el-button @click="handlePreview(row)" type="text"
                    >预览/下载</el-button
                  >
                  <el-button
                    @click="changeAcCard(row)"
                    type="text"
                    v-if="search.isPrivate==1"
                    >{{ row.isVisiable == 1 ? '公开' : '保密' }}</el-button
                  >
                  <el-button @click="reuse(row)" class="mb" type="text"
                    >复用</el-button
                  >
                  <el-popconfirm
                    v-if="search.isPrivate==1"
                    title="确定删除吗？删除后不能恢复数据"
                    @confirm="handleDelete(row)"
                    style="margin-left: 10px"
                  >
                    <el-button
                      icon="el-icon-document-delete"
                      slot="reference"
                      type="text"
                      style="color: red"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 10px" v-if="total > 0">
              <Pagination
                :total="total"
                :size="search.pageSize"
                :page="search.currentPage"
                @handlePageSizeChange="handleSizeChange"
              >
              </Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="preview-wrapper"
      :class="{ 'hide-score': !!answerSheet.acCardHideScore }"
    >
      <div v-if="isPreview">
        <!-- <div
          class="close el-icon-error"
          @click="handlePreviewClose(true)"
        ></div> -->
        <div class="close-down">
          <el-button type="primary" size="small" @click="downloadPdfAction"
            >下载</el-button
          >
          <el-divider direction="vertical"></el-divider>
          <el-button type="info" size="small" @click="handlePreviewClose(true)"
            >关闭</el-button
          >
        </div>
        <!-- 答题卡预览区 -->
        <div id="preview-page-wrap">
          <preview-wrapper
            :is-preview="isPreview"
            :preAcCardGuid="preAcCardGuid"
          ></preview-wrapper>
        </div>
      </div>
    </div>
    <changeSchool ref="changeSchool" :user="user"></changeSchool>
  </div>
</template>

<script>
import AcCardApi from '@/services/acCard';
import AcDialog from './components/AcDialog';
import $ from 'jquery';
import JsPDF from 'jspdf';
import * as QRCode from 'qrcodejs2';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import PreviewWrapper from '@/views/PreviewWrapper';
import { studentMsgEffect, getChinese } from '@/utils/common';
import { v4 as uuidv4 } from 'uuid';
import makeCard from '../services/makeCard';
//预览相关
import { BlankModel } from '../subjects/blank/Blank.model';
import { ObjectiveModel } from '../subjects/objective/Objective.model';
import { AnswerModel } from '../subjects/answer/Answer.model';
import { WriteEnModel } from '../subjects/writeEn/WriteEn.model';
import { WriteModel } from '../subjects/write/Write.model';
import { ChooseModel } from '../subjects/choose/Choose.model';
import MyPage from '@/subjects/Page';
import { DEFAULT_PAGECELL, THS, THSObj } from '@/subjects/constant';
import changeSchool from './changeSchool.vue';
// 用来恢复json序列化的对象方法
const SUBJECTS_TYPE_MAP = {
  1: BlankModel,
  2: ObjectiveModel,
  3: AnswerModel,
  4: WriteEnModel,
  5: WriteModel,
  6: ChooseModel,
};
export default {
  name: 'Home',
  components: {
    AcDialog,
    PreviewWrapper,
    changeSchool,
  },
  data() {
    return {
      acCardList: [],
      acDialogV: false, //控制新建DTK弹框开关
      // 以上是弹窗的参数
      modalTemplateAddParams: {},
      typeList: [],
      search: {
        acKmCode: '',
        acksType: '',
        acPeriod: '',
        acCardName: '',
        pageSize: 10,
        currentPage: 1,
        isPrivate: 1,
      },
      layerList: [
        {
          lay: false,
        },
      ],
      // subjects: [],
      grades: [],
      examType: [],
      isPreview: false,
      currentRow: {},
      acsubjects: [],
      preAcCardGuid: null,
      showUploader: false,
      total: 0,
      isPrivate: 1,
    };
  },
  filters: {
    // 1、一栏，2、两栏，3三栏'
    acCardPanesFilter: function (val) {
      if (val == 1) {
        return '一栏';
      } else if (val == 2) {
        return '两栏';
      } else if (val == 3) {
        return '三栏';
      }
    },
    acCardYJTypeFilter: function (val) {
      if (val == 0) {
        return '手批';
      } else if (val == 1) {
        return '网阅';
      }
    },
    acCardStudentCodeTypeFilter: function (val) {
      if (val == 1) {
        return '条码';
      } else if (val == 2) {
        return '手写考号';
      } else if (val == 0) {
        return '填涂';
      }
    },
  },
  mounted() {
    this.GetBasicDropDownDatas();

    this.getAcCardList();
    console.log('user:::', this.user);
  },
  computed: {
    ...mapGetters({
      answerSheet: 'answerPanel/answerSheet',
      user: 'account/user',
    }),
    ...mapState('card', {
      pageCell: (state) => state.pageCell, //纸张的数据
      subjects: (state) => state.subjects, //纸张的数据
      pageCellCopy: (state) => state.pageCellCopy, //纸张的数据
      pageCellString: (state) => state.pageCellString,
    }),
    logo() {
      return process.env.VUE_APP_LOGO ? require(process.env.VUE_APP_LOGO) : '';
    },
  },

  methods: {
    ...mapMutations({
      setToken: 'account/setToken',
      setkMAndPeriod: 'card/setkMAndPeriod',
      resetPosition: 'card/resetPosition',
      setPageCellString: 'card/setPageCellString',
      setCurrentPageNum: 'card/setCurrentPageNum',
      resetPosition: 'card/resetPosition',
      returnPosition: 'card/returnPosition',
      restorePageCell: 'card/restorePageCell',
      setPageCell: 'card/setPageCell',
      setSubjects: 'card/setSubjects',
      resetPageCell: 'card/resetPageCell',
      setTHS: 'card/setTHS',
      setPageCellString: 'card/setPageCellString',
      setBasicsCheckList: 'card/setBasicsCheckList',
    }),
    ...mapActions({
      answerSheetAction: 'answerPanel/answerSheetAction',
    }),
    changeType(e){
      this.search.isPrivate = e;
      this.getAcCardList();
    },
    searchClick() {
      this.search.currentPage = 1;
      this.getAcCardList();
    },
    handleSizeChange(pageIndex, pageSize) {
      this.search.pageSize = pageSize;
      this.search.currentPage = pageIndex;
      this.getAcCardList();
    },
    handleUploadSuccess(res) {
      console.log('handleUploadSuccess:::', res);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: '上传成功!',
        });
        this.getAcCardList();
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
        });
      }
    },
    GetBasicDropDownDatas() {},
    handleCommand(command) {
      switch (command) {
        case 'logout':
          this.loginOut();
          break;
        case 'modify':
          this.$router.push({ path: '/modify' });
          break;
        case 'change':
          this.$refs['changeSchool'].open();
          break;
        default:
          break;
      }
    },
    loginOut() {
      this.setToken('');
      this.$router.push('/login');
    },
    createDtk() {
      this.$router.push({
        path: '/cardNew',
        query: { guid: uuidv4() },
      });
    },
    handleDelete(row) {
      let data = { id: row.dtkguid };
      AcCardApi.DelAcCard(data).then((res) => {
        this.getAcCardList();
      });
    },
    getChinsesCardName(name) {
      console.log('getChinsesCardName======log', name, getChinese(name));
      return getChinese(name);
    },
    /** 复用答卷 */
    reuse(row) {
      this.$confirm('是否复用此答题卡?', '确认复用', {
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        AcCardApi.ReuseAcCard({ acCardGuid: row.dtkguid }).then((res) => {
          if (res.errno == 0) {
            this.getAcCardList();
            // this.$router.push({
            //   path: "/cardNew",
            //   query: { guid: res.data.acCardGuid },
            // });
            this.$message({
              type: 'success',
              message: '复用成功!',
            });
          }
        });
      });
    },

    /** 复用答卷 */
    changeAcCard(row) {
      AcCardApi.changeAcCard({ acCardGuid: row.dtkguid }).then((res) => {
        this.getAcCardList();
      });
    },
    /**  */
    handleEdit(row) {
      this.$router.push({
        path: '/cardNew',
        query: { guid: row.dtkguid },
      });
    },
    async handlePreview(row) {
      this.preAcCardGuid = row.dtkguid;
      let data = await this.fetchCardDetails(row.dtkguid);
      let { acCard, acCardHtml, acCardQuestTh, acQuestType } = data;
      // 如果是组卷第一次直接读组卷 第二次读保存的html
      if (acCardHtml && acCardHtml.designText) {
        const designText = JSON.parse(acCardHtml.designText);
        let acCardName = acCard.acCardName.replace(
          /<p>/gi,
          '<p class="ac-card-name">'
        );
        this.renderPageByDesignTxt(designText);
        this.answerSheetAction({
          ...acCard,
          acCardName: acCardName,
          acCardNameHtml: acCardHtml.acCardName,
        });
        console.log('acCardNameHtml========log', acCardHtml);
      }
      // 这里用定时器的原因是，富文本编辑器失焦才会保存数据，用户如果编辑完直接点击预览，数据不能及时保存
      let timer = setTimeout(() => {
        document.querySelector('.preview-wrapper').style.opacity = 1;
        document.querySelector('.preview-wrapper').style.zIndex = 200000;
        // document.querySelector(".preview-wrapper").style.fontFamily = '"Helvetica Neue",Helvetica,Arial,sans-serif'
        this.isPreview = true;
        studentMsgEffect();
        this.resetPosition(this.answerSheet);
        this.setPageCellString(JSON.stringify(this.pageCell));
        clearTimeout(timer);
      }, 1000);
      //
      this.currentRow = row;

      // this.$nextTick(() => {
      //     this.initQRCode(row.id)
      // });
    },
    async fetchCardDetails(acCardGuid) {
      const data = await this.getDetailAcCard(acCardGuid);
      return data;
    },
    //
    async fetchCardDetail(acCardGuid) {
      const data = await this.getDetailAcCard(acCardGuid);
      let { acCard, acCardHtml, acCardQuestTh, acQuestType } = data;
      if (acCard && (acCard.acCardDJType == 0 || acCard.acCardDJType == 2)) {
        // 自制
        this.answerSheetAction({
          ...acCard,
          acCardName: acCard.acCardName,
        });
        // acCard.acCardName.replace(/<p>/gi, '<div>')
        // console.log('=======  =======', acCard.acCardName);
        if (!acCardHtml.designText) {
          // 这里存在扫描题卷情况 先判断有没有designtext字段 没有再判断acCardQuestTh 都没有才能生成空的答题卷
          if (Array.isArray(acCardQuestTh) && acCardQuestTh.length) {
            this.createPageCellByZj(acCard, acCardQuestTh, acQuestType);
          } else {
            this.setPageCell(DEFAULT_PAGECELL);
            this.setSubjects([]);
            this.setTHS(THS);
            this.resetPageCell({
              acCardPanes: acCard.acCardPanes,
            });
          }
          return;
        }
        studentMsgEffect();
        const designText = JSON.parse(acCardHtml.designText);
        if (Array.isArray(designText)) {
          this.setPageCell(designText);
          this.setTHS(THS);
        } else {
          const { pageCell, subjects, THList, acCardName, basicsCheckList } =
            designText;
          this.renderPageByDesignTxt(designText);
        }
      } else {
        // 如果是组卷第一次直接读组卷 第二次读保存的html
        if (acCardHtml && acCardHtml.designText) {
          const designText = JSON.parse(acCardHtml.designText);
          this.renderPageByDesignTxt(designText);
          this.answerSheetAction({
            ...acCard,
          });
        } else {
          this.createPageCellByZj(acCard, acCardQuestTh, acQuestType);
          this.answerSheetAction({
            ...acCard,
            acCardName: acCard && acCard.acCardName,
          });
        }
      }
      return data;
    },
    async getDetailAcCard(acCardId) {
      let { data } = await makeCard.getDetailAcCard({
        acCardId: acCardId,
        abType: 0,
      });
      if (data) {
        let { acCard, acCardHtml, acCardQuestTh, acQuestType } = data;
        this.acCardQuestTh = acCardQuestTh || []; //自制答题卡 除了第一次新增之后 每次修改大题题型都需要acCardQuestTh中的questTh_Guid
        this.acCardCardID = acCard.acCardCardID || '';
      }
      return data || {};
    },
    renderPageByDesignTxt(designText) {
      const { pageCell, subjects, THList, acCardName, basicsCheckList } =
        designText;
      acCardName &&
        this.answerSheetAction({
          acCardName: acCardName,
        });
      basicsCheckList && this.setBasicsCheckList(basicsCheckList);
      subjects &&
        subjects.forEach((subject) => {
          Object.setPrototypeOf(
            subject,
            SUBJECTS_TYPE_MAP[subject.type].prototype
          );
          Object.setPrototypeOf(subject.page, MyPage.prototype);
        });
      this.setPageCell(pageCell || '');
      this.setSubjects(subjects || []);
      console.log('fetchCardDetail', designText, this.subjects);
      const sortTHS = [...new Set(THList)].sort((a, b) => {
        return THSObj[a] - THSObj[b];
      });
      this.setTHS(sortTHS);
    },
    createPageCellByZj(acCard, acCardQuestTh, acQuestType) {
      // 组卷
      this.answerSheetAction(acCard);
      const resultSubjects = transformSubjects(acCardQuestTh, acQuestType, {
        BlankModel,
        AnswerModel,
        WriteEnModel,
        WriteModel,
        ChooseModel,
        ObjectiveModel,
      });
      this.setSubjects(resultSubjects);
      this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: 0,
      });
    },
    handlePreviewClose() {
      this.isPreview = false;
      document.querySelector('.preview-wrapper').style.zIndex = -1;
    },
    downloadPdfAction() {
      this.$message({
        dangerouslyUseHTMLString: true,
        message: '<strong>生成答题卡PDF中,请稍后......</strong>',
        duration: 0,
      });
      // 因为html2Canvas不能将隐藏的元素保存下来 所以要先显示然后将元素opacity置为0
      this.isDownload = true;
      studentMsgEffect();
      const timer = setTimeout(() => {
        // this.handlePreview();
        document.querySelector('.preview-wrapper').style.opacity = 1;
        document.querySelector('.preview-wrapper').style.zIndex = 200000;
        this.isPreview = true;
        this.resetPosition(this.answerSheet);
        document.querySelector('.preview-wrapper').style.zIndex = -1;
        let myPdfDom = document.querySelector('#preview-page');
        this.getPdf(myPdfDom)
          .then((canvas) => {
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;
            if (this.answerSheet.acCardPanes === 1) {
              this.savePdfA4(canvas, contentWidth, contentHeight);
            } else {
              this.savePdfA3(canvas, contentWidth, contentHeight);
            }
            this.$message.closeAll();
            this.handlePreviewClose();
            this.$message({
              message: '操作成功~',
              type: 'success',
            });
          })
          .catch((e) => {})
          .then(() => {
            this.isDownload = true;
            this.$message.closeAll();
          });
        clearTimeout(timer);
      }, 100);
    },
    savePdfA4(canvas, contentWidth, contentHeight) {
      let pageHeight = (contentWidth / 595.28) * 841.89;
      let leftHeight = contentHeight;
      let position = 0;
      let imgWidth = 595.28;
      let imgHeight = (602 / contentWidth) * contentHeight;
      let pageData = canvas.toDataURL('image/jpeg', 1.0);
      let PDF = new JsPDF('', 'pt', 'a4');
      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
      } else {
        while (leftHeight > 0) {
          PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          // 每页会多出17点多的长度 所以拿18乘以页数
          if (leftHeight > parseInt(contentHeight / pageHeight) * 18) {
            PDF.addPage();
          }
        }
      }
      PDF.save(this.filterPTags(this.currentRow.acCardName) + '.pdf');
    },
    savePdfA3(canvas, contentWidth, contentHeight) {
      let pageHeight = (contentWidth / 1191) * 842;
      let leftHeight = contentHeight;
      let position = 0;
      let imgWidth = 1191;
      let imgHeight =
        ((this.answerSheet.acCardPanes === 2 ? 1200 : 1355) / contentWidth) *
        contentHeight;
      let pageData = canvas.toDataURL('image/jpeg', 1.0);
      let PDF = new JsPDF('l', 'pt', 'a3');
      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
      } else {
        const pageLen =
          parseInt(contentHeight / pageHeight) *
          (this.answerSheet.acCardPanes === 2 ? 21 : 0);
        while (leftHeight > 0) {
          PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 842;
          if (leftHeight > pageLen) {
            PDF.addPage();
          }
        }
      }
      PDF.save(this.filterPTags(this.currentRow.acCardName) + '.pdf');
    },
    //过滤标题标签
    filterPTags(str) {
      const regex = /<p>(.*?)<\/p>/g;
      let match;
      const results = [];

      while ((match = regex.exec(str))) {
        results.push(match[1]);
      }

      return results;
    },
    GetBasicDropDownDatas() {
      AcCardApi.GetBasicDropDownDatas().then((res) => {
        const { examType, grades, subjects } = res.data;
        this.examType = examType;
        this.grades = grades;
        this.acsubjects = subjects;
        //
        this.setkMAndPeriodState(res.data);
      });
    },
    setkMAndPeriodState(data) {
      const { examType, grades, subjects } = data;
      const myKMAndPeriod = {
        km: subjects,
        period: grades,
        ksType: examType,
      };
      this.setkMAndPeriod(myKMAndPeriod || { km: [], period: [], ksType: [] });
    },
    // 添加答题卡 获取科目、学段 和模板
    addAcCrad() {
      // this.acDialogV = true;
      this.$router.push('/cardNew');
    },
    getAcCardList() {
      AcCardApi.GetAcCardList(this.search).then((res) => {
        this.total = res.data.count;
        this.acCardList = res.data.data;
      });
    },
    //显示考生信息
    showBasics(pageIndex) {
      let showBasics = false;
      const { acCardPanes, acCardPint } = this.answerSheet;
      if (pageIndex === 0) {
        return true;
      }
      if (acCardPanes === 1) {
        // 一栏
        if (acCardPint == 1) {
          // 单面打印
          return true;
        } else if (acCardPint == 2) {
          // 双面打印
          return (pageIndex + 1) % 2 == 1 ? true : false;
        }
      } else if (acCardPanes === 2) {
        // 二栏
        if (acCardPint == 1) {
          // 单面打印
          return (pageIndex + 1) % 2 == 1 ? true : false;
        } else if (acCardPint == 2) {
          // 双面打印
          return (pageIndex + 1) % 4 == 1 ? true : false;
        }
      } else {
        // 三栏
        if (acCardPint == 1) {
          // 单面打印
          return (pageIndex + 1) % 3 == 1 ? true : false;
        } else if (acCardPint == 2) {
          // 双面打印
          return (pageIndex + 1) % 6 == 1 ? true : false;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.card-content {
  textarea {
    resize: none !important;
  }

  .ab-box {
    //overflow: hidden;

    // border: 1px solid #dcdfe6;
    // border-radius: 4px;
    .a-b {
      border: none;
      /*border: 1px solid #000;*/
      float: left;
      /*height: 66px;*/
      width: 10%;
      margin-right: 8px;

      /*.c-b0 {*/
      /*  background: #000;*/
      /*}*/
      .no-margin {
        margin-right: 0;
        margin-left: 0;
      }

      .mt {
        margin-bottom: 5px;
      }
    }

    .AB_wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .input-name {
    width: 70%;
  }

  .ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label {
    width: 3em;
  }

  .topic-bd {
    padding: 0 15px !important;

    .fill-cont {
      overflow: visible;
    }
  }

  .message-box {
    width: 100%;

    .message-con {
      position: fixed;
      top: 62px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      margin: 0 auto;
      font-size: 16px;
      width: 540px;
      color: #f00;
      border: 1px solid #f00;
      z-index: 9;
    }
  }

  .code-info {
    position: absolute;
    left: 44px;
    top: 4px;
    width: 300px;
    height: 47px;

    .appTitle {
      display: inline-block;
      font-size: 12px;
      vertical-align: middle;
      height: 57px;
      padding-left: 4px;
    }

    img {
      width: 60px;
      max-width: 100%;
      max-height: 60px;
    }
  }

  .card-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 16px;
    text-align: center;
    position: relative;

    .el-input__count {
      right: 20px;
    }
  }

  .wrapper-content {
    // border: 1px solid #409eff;
    border-radius: 10px;
    // padding: 0 10px;
    // padding: 0 10px 10px 10px;
  }

  .card-tool {
    height: 40px;
    padding-top: 20px;
    background: linear-gradient(to right, #4891ff, #21cfff);
    color: #fff;
    padding-left: 20px;

    .submit-text {
      position: relative;
      top: -10px;
      cursor: pointer;
      width: 60px;
      text-align: center;
    }

    .custom-row {
      .custom-col {
        margin-right: 20px;

        &:first-child,
        &:nth-child(5) {
          margin-right: 40px;
        }

        &:nth-child(2) {
          margin-right: auto;
          margin-top: -10px;
        }
      }
    }
  }

  .card-make-box {
    display: flex;
    flex: auto;
    box-sizing: border-box;
    height: calc(100vh - 60px) !important;
    overflow: hidden;

    .bd-le {
      height: 100%;
      overflow-y: auto;

      flex: 1;
      height: 100%;
      overflow: scroll;
      position: relative;
      // padding-bottom: 100px;
      // overflow: visible;
    }

    .bd-ri {
      position: relative;
      float: right;
      width: 440px;
      background: #fff;
      height: 100%;
      overflow-y: auto;
    }

    .disabled_mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000;
      z-index: 9;
      cursor: not-allowed;
      opacity: 0.3;
    }

    .fix-box {
      position: absolute;
      left: -15px;
      top: 100px;
    }

    .card-content {
      // font-size: 3mm;
      //font-family: 宋体, SimSun, "STSong";
      // font-family: "Verdana", "宋体";
      position: relative;
      color: #000000;
      width: 794px;
      margin: 0 auto;
    }
  }

  .preview-wrapper {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    z-index: -1;
    // font-family: "Verdana", "宋体";
    color: #000;
    background: #f1f1f1;

    .close-down {
      position: fixed;
      top: 10px;
      right: 100px;
      z-index: 10;
      padding: 6px 8px;
      border-radius: 8px;
      border: 1px solid #f8f8f8;
      box-shadow: rgba(0, 0, 0, 0.1) 0 2px 5px 4px;
      z-index: 1000;
      display: flex;
      align-items: center;
    }

    .close {
      border: 1px solid #fff;
      position: fixed;
      margin-top: 10px;
      font-size: 42px;
      right: 30px;
      z-index: 1004;
      cursor: pointer;
      background: #fff;
      border-radius: 25px;
    }

    .close_wait {
      cursor: wait;
    }

    .card-content {
      margin: 0 auto;
      height: 100%;
      position: relative;
    }

    .topic-box {
      overflow: hidden;

      .topic-bd {
        word-break: break-word;
      }

      p.row {
        min-height: 38px;
        line-height: 38px;
        word-spacing: 0;
      }

      p {
        min-height: 38px;
        margin: 0 !important;
      }

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .page-cell {
    //border: solid 1px black;
    background: #fff;
    //height: 1123px;
    padding: 0;

    .position_point {
      position: absolute;
      width: 22px;
      height: 11px;
      background: #000;
    }

    #barcode {
      position: absolute;
      width: 100px;
      height: 50px;
      bottom: 4px;
      z-index: 999;
      right: -53px;
    }

    .left {
      left: 16px;
      top: 25px;
    }

    .top {
      right: 16px;
      top: 25px;
    }

    .bottom {
      bottom: 25px;
      left: 16px;
    }

    .right {
      right: 16px;
      bottom: 25px;
    }
  }

  .ck-content,
  .ck-content.ck-editor__editable_inline,
  .ck-content.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
    // padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .topic-box {
    position: relative;
    // overflow: hidden;
    // margin-top: 10px;
  }

  .topic-th {
    position: relative;
    min-height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  .topic-bd {
    position: relative;
    overflow: hidden;
    // border: 1px solid #000 !important;

    .move-h {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #409eff;
      font-size: 20px;
      z-index: 2004;
      cursor: pointer;
    }

    .ck-content {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .ck-content.ck-editor__editable_inline > :last-child {
      margin-bottom: 0;
    }

    .ck-content.ck-editor__editable_inline > :first-child {
      padding-top: 39px;
      margin-top: 0 !important;
    }
  }

  .kfformula {
    vertical-align: middle;
  }

  .move-tips {
    position: absolute;
    left: 101%;
    bottom: 0;
    width: 100px;
  }

  #div1 {
    min-height: 100px;
    width: 100%;
    border: 1px solid #000;
  }
}

.ac-card-name {
  line-height: 22px;
  min-height: 22px;
  text-align: center;
  font-size: 16px;
}

.app-wrapper {
  box-sizing: border-box;
  position: relative;
  background-color: #fff;
}

.fixed-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 56px;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.3);
}

.navbar-container {
  width: 1400px;
  max-width: 1400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar-container .sidebar-left {
  display: flex;
  flex-direction: row;
}

@media (min-width: 1400px) {
  .logo .sidebar-logo-link {
    margin-left: -5px !important;
  }
}

.logo .sidebar-logo-link {
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.logo .sidebar-logo-link .sidebar-logo {
  width: auto;
  height: 36px;
  vertical-align: middle;
  margin: 0 18px;
}

.logo .sidebar-logo-link .list-icon {
  margin-right: 5px;
  width: 18px;
  height: 18px;
}

.logo .sidebar-logo-link .logtitle {
  color: #303133;
  font-size: 15px;
  display: flex;
  align-items: center;
}

.logo .sidebar-title {
  margin: 0;
  font-weight: 400;
  font-size: 17px;
  vertical-align: middle;
  border-left: 1px solid #222;
  padding: 0 20px;
}

.logo .sidebar-title:hover {
  color: #1890ff;
  cursor: pointer;
}

.user-menus-container {
  margin-left: auto;
  height: 56px;
  line-height: 56px;
  display: flex;
  align-items: center;
}

.detail-container {
  box-sizing: border-box;
  position: relative;
}

.appmain {
  position: fixed;
  height: calc(100vh - 56px);
  background-color: #eceff3;
  overflow-x: hidden;
  overflow-y: auto;
  top: 56px;
  width: 100vw;
}

.HomeIndex {
  position: relative;
  background-color: #f2f3f6;
  height: calc(100% - 20px);
  width: 100%;
  max-width: 1400px;
  max-height: 940px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px auto 0;
  box-sizing: border-box;
}
</style>
<style lang="scss">
.container {
  position: relative;
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
}

.container-pdf {
  position: absolute;
  height: 1000px;
  opacity: 0;
  z-index: -1000;
  overflow-y: hidden;

  .card-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 16px;
    padding: 0;
    text-align: center;
    // font-weight: bold;
    min-height: 30px;
    position: relative;
  }
}

.cont-list {
  width: 80%;
  /*min-height: 820px;*/
  background: #fff;
  margin: 30px 10%;
  padding: 20px;
  position: absolute;
  left: 0;
  top: 50px;

  /* width: 1140px;
     margin: 0 auto;
    background: #fff;
    border: 1px solid #c7c0b6; */
  .el-table {
    color: #333;
  }

  .pagination-card {
    text-align: right;
    padding: 30px;

    .el-pagination__total {
      float: left;
    }

    .el-pagination__sizes {
      float: left;
    }
  }

  .search {
    width: 500px;
    float: right;
    text-align: right;

    /*overflow: ;*/
    .input-with-select {
      float: right;
      width: 240px;
    }

    .button-with-select {
      float: right;
      margin-left: 10px;
    }
  }

  .el-select {
    margin-right: 10px;
  }

  .el-select .el-input {
    width: 120px;
  }

  .el-input-group__prepend {
    background: none;
  }

  .sel-config {
    line-height: 38px;
    border-top: 1px solid #ebeef5;

    .el-checkbox-button__inner {
      border: 0;
      margin: 0 5px;

      &:hover {
        border: 0;
        box-shadow: none;
      }
    }

    .el-checkbox-button--mini .el-checkbox-button__inner,
    .el-checkbox-button.is-checked .el-checkbox-button__inner,
    .el-checkbox-button:first-child .el-checkbox-button__inner,
    .el-checkbox-button:last-child .el-checkbox-button__inner {
      border: 0;
      border-radius: 4px;
      box-shadow: none;
    }
  }

  .pad-t-d {
    padding: 20px 0;
  }

  .ac-list {
    margin-top: 20px;
    border-top: 1px solid #ebeef5;
  }
}

.more-wrap {
  min-width: 62px !important;

  .operation-ul {
    display: flex;
    flex-direction: column;
    margin: 3px 0;

    span {
      color: #409eff;
      cursor: pointer;
    }

    .mb {
      margin-bottom: 12px;
    }
  }
}

.preview-wrapper {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  z-index: -1;
  // font-family: "Verdana", "宋体";
  color: #000;
  background: #fff;

  .close-down {
    position: fixed;
    top: 10px;
    right: 100px;
    z-index: 10;
    padding: 6px 8px;
    border-radius: 8px;
    border: 1px solid #f8f8f8;
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 5px 4px;
    z-index: 1000;
    display: flex;
    align-items: center;
  }

  .close {
    border: 1px solid #fff;
    position: fixed;
    margin-top: 10px;
    font-size: 42px;
    right: 30px;
    z-index: 1004;
    cursor: pointer;
    background: #fff;
    border-radius: 25px;
  }

  .close_wait {
    cursor: wait;
  }

  .card-content {
    margin: 0 auto;
    height: 100%;
    position: relative;
  }

  .topic-box {
    overflow: hidden;

    .topic-bd {
      word-break: break-word;
    }

    p.row {
      min-height: 38px;
      line-height: 38px;
      word-spacing: 0;
    }

    p {
      min-height: 38px;
      margin: 0 !important;
    }

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.user-dropdown {
  border-radius: 20px;
  font-size: 14px;
  color: #666;
  border: 1px solid #eee;
  background-color: #f8f9f9;
  margin-left: 30px;
}

.el-dropdown {
  cursor: pointer;
}

.el-dropdown {
  display: inline-block;
  position: relative;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.user-dropdown .el-dropdown-link {
  padding: 6px 16px;
}

[align-items-center] {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.user-dropdown .ru {
  padding-right: 6px;
  border-right: 2px solid #e8e8e8;
  max-width: 150px;
  margin-right: 6px;
}

.user-dropdown .ru,
.user-dropdown .username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  line-height: 20px;
}

.user-dropdown-items {
  padding-top: 0px;
}

.user-dropdown-items .school-item:before {
  content: attr(data-unit);
  position: absolute;
  top: -20px;
  left: -20px;
  display: inline-block;
  width: 30px;
  height: 40px;
  background: #1890ff;
  line-height: 58px;
  padding-left: 23.52941px;
  border-radius: 20px;
  font-size: 12px;
  color: #fff;
}

.user-dropdown-items .el-dropdown-menu__item {
  padding: 0 30px;
}

.user-dropdown-items .school-item {
  position: relative;
  overflow: hidden;
  max-width: 220px;
  line-height: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.user-dropdown-items .el-dropdown-menu__item + .account-item {
  border-top: 1px solid #eee;
  padding-top: 6px;
  padding-bottom: 6px;
}

.user-dropdown-items .school-item .rucode {
  color: #909399;
  font-size: 14px;
}

.user-dropdown-items .school-item[data-unit='校']:before {
  background: #36c67d;
}
.card-type{
  margin: 20px 0;
}
</style>
